import { combineReducers } from "redux";

import { companyConstants } from "../actions/deadlines/company";
import { exportConstants } from "../actions/deadlines/export";

function filtersActive(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? null : state;
  switch (type) {
  case companyConstants.GET_DEADLINES_SUCCESS:         
    return payload?.isSaveFilter ? payload?.queryParameters : defaultS?.filtersActive ? defaultS?.filtersActive : null;
  default:
    return defaultS;
  }
}

function subjective(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? [] : state;
  switch (type) {
  case companyConstants.CLEAR_DEADLINES_LIST:
    return [];
  case companyConstants.GET_DEADLINES_ERROR:
    return null;
  case companyConstants.GET_DEADLINES_SUCCESS:
    /** !!! NECESSARIO per la paginazione. Se sorgono problemi individuare il punto 
     * in cui fare eventualmente la clear */
    return payload && payload._embedded && payload._embedded.deadlines && !payload.isRefresh ? defaultState.concat(payload._embedded.deadlines) : payload.isRefresh ? payload._embedded.deadlines : [];
  case companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_SUCCESS:
    return payload && payload.deadlines ? payload.deadlines : [];
  case companyConstants.SET_DEADLINES_ARCHIVED_SUCCESS:
    if (defaultState && payload && payload.id) {
      let copyObjDeadlines = typeof defaultState === "object" ? defaultState : [];
      let actualDeadlines = copyObjDeadlines.find((el) => {
        return el.id === payload.id;
      });
      if (actualDeadlines) {
        actualDeadlines.status.archived = payload.archived;
      }
      return copyObjDeadlines;
    } return defaultState;
  case companyConstants.REMOVE_DEADLINES_TO_LIST:
    if (defaultState && payload && payload.length > 0) {
      let copyObjDeadlines = [];
      defaultState.map((deadline) => {
        if (payload.indexOf(deadline.id) === -1) {
          copyObjDeadlines.push(deadline);
        }
        return null;
      });
      return copyObjDeadlines;
    } return defaultState;
  default:
    return defaultState;
  }
}

function _links(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {  
  case companyConstants.GET_DEADLINES_ERROR:
    return null;
  case companyConstants.GET_DEADLINES_SUCCESS:
    return payload && payload._links ? payload._links : []; 
  default:
    return defaultState;
  }
} 

function subjectiveMonth(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case companyConstants.GET_DEADLINES_MONTH_ERROR:
    return null;
  case companyConstants.GET_DEADLINES_MONTH_SUCCESS:
    return payload && payload._embedded && payload._embedded.deadlines ? payload._embedded.deadlines : [];
  default:
    return defaultState;
  }
}

function isGettingDeadlinesMonth(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case companyConstants.GET_DEADLINES_MONTH_START:
    return true;
  case companyConstants.GET_DEADLINES_MONTH_SUCCESS:
  case companyConstants.GET_DEADLINES_MONTH_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isGettingDeadlines(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case companyConstants.GET_DEADLINES_START:
    return true;
  case companyConstants.GET_DEADLINES_SUCCESS:
  case companyConstants.GET_DEADLINES_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isGettingDeadlinesGroupingByScope(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_START:
    return true;
  case companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_SUCCESS:
  case companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingDeadlines(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case companyConstants.GET_DEADLINES_ERROR:
    return error ? error : true;
  case companyConstants.GET_DEADLINES_START:
  case companyConstants.GET_DEADLINES_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isArchivingDeadlines(state = false, { type }) {
  // let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case companyConstants.SET_DEADLINES_ARCHIVED_START:
    return true;
  case companyConstants.SET_DEADLINES_ARCHIVED_SUCCESS:
  case companyConstants.SET_DEADLINES_ARCHIVED_ERROR:
    return false;
  default:
    return state;
  }
}

function isErrorArchivingDeadlines(state = false, { type, error }) {
  // let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case companyConstants.SET_DEADLINES_ARCHIVED_ERROR:
    return error ? error : true;
  case companyConstants.SET_DEADLINES_ARCHIVED_START:
  case companyConstants.SET_DEADLINES_ARCHIVED_SUCCESS:
    return false;
  default:
    return state;
  }
}

function isExportingDeadlines(state = false, { type, error }) {  
  switch (type) {
  case exportConstants.DEADLINES_EXPORT_START:
    return true;
  case exportConstants.DEADLINES_EXPORT_SUCCESS:
  case exportConstants.DEADLINES_EXPORT_ERROR:
    return false;
  default:
    return state;
  }
}

let defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function createDeadline(state = defaultState, { type, payload }) {
  switch (type) {
  case companyConstants.CREATE_DEADLINES_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case companyConstants.CREATE_DEADLINES_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case companyConstants.CREATE_DEADLINES_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {  message: payload.message }
      }
    };
  case companyConstants.CREATE_DEADLINES_RESET:
    return {
      ...defaultState
    };
  default:
    return state;
  }
}

export const deadlinesCompany = combineReducers({
  createDeadline,
  subjective,  
  _links,
  filtersActive,
  subjectiveMonth,  
  isGettingDeadlines,  
  isGettingDeadlinesMonth,
  isErrorGettingDeadlines,  
  isArchivingDeadlines,
  isErrorArchivingDeadlines,  
  isGettingDeadlinesGroupingByScope,
  isExportingDeadlines
});

export default deadlinesCompany;
